export const BASE_URL_API = window.base_url_api

export const APP_NAME = "SIAKRI (Sistem Informasi Akademik Profesi)"
export const APP_NAME_SHORT = "SIAKRI"
export const APP_RSGM = "RSGM UGM Prof. Soedomo"